import { BaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { ssApiService } from '../../services/ss-api.service';
import { Component, OnInit } from '@angular/core';

import Swal, { SweetAlertIcon } from 'sweetalert2';
import { CdKeyReassignRequest } from '../../models/ss-api/requests/cdkey.reassign.request';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

export interface IReassignDialogModel {
  title: string;
  subTitle: string;
  message: string;
  LicenseKey: string;
  FirstName: string;
  LastName: string;
  Email: string;
  ShowDesigner: boolean;
}

@Component({
  selector: 'cdkey-reassign-dialog',
  styleUrls: ['./cdkey-reassign-dialog.component.scss'],
  templateUrl: './cdkey-reassign-dialog.component.html'
})
export class CDKeyReassignDialogComponent implements OnInit, IReassignDialogModel {


  confirmTitle: string = 'Reassign License Key';
  confirmMessage: string = 'You are about to reassign this license key. Do you wish to proceed?';

  successTitle: string = 'Reassign successfull';
  successMessage: string = 'Your license is open to assign.';

  errorTitle: string = 'Error';
  errorMessage: string = 'We were not able to open your license for reassign. Contact support.';

  cancelledTitle: string = 'Cancelled';
  cancelledMessage: string = 'You cancelled the reassignment.';

  title: string;
  subTitle: string;
  message: string;
  LicenseKey: string;
  FirstName: string;
  LastName: string;
  Email: string;
  ShowDesigner: boolean;

  FullName: string;

  OrderForm: UntypedFormGroup = new UntypedFormGroup({});

  // NEW USER INFO
  newName: string = 'newName';
  newEmail: string = 'email@email.com';

  result: any;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private api: ssApiService
  ) {
  }

  ngOnInit(): void {
    this.title = this.config.data.title;
    this.subTitle = this.config.data.subTitle;
    this.message = this.config.data.message;
    this.LicenseKey = this.config.data.LicenseKey;
    this.FirstName = this.config.data.FirstName;
    this.LastName = this.config.data.LastName;
    this.Email = this.config.data.Email;
    this.ShowDesigner = this.config.data.ShowDesigner;
    this.FullName = this.GetFullName();
    this.SetUpForm();
  }

  close() {
      this.ref.close();
  }

  get f() { return this.OrderForm.controls; }

  SetUpForm() {
    this.OrderForm = new UntypedFormGroup({
      'f_name': new UntypedFormControl(this.FullName, [Validators.required, Validators.minLength(3)]),
      'f_email': new UntypedFormControl(this.Email, [Validators.required, Validators.email]),
      'f_newName': new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
      'f_newEmail': new UntypedFormControl('', [Validators.required, Validators.email]),
      'f_confirmEmail': new UntypedFormControl('', [Validators.required, Validators.email]),
    });
  }

  ProcessReassign(): Promise<any> {

    let request = new CdKeyReassignRequest();
    request.Key = this.LicenseKey;
    request.Name = this.OrderForm.controls['f_newName'].value;
    request.NotifyEmail = this.OrderForm.controls['f_newEmail'].value;

    // confirm
    return Swal.fire({
      title: this.confirmTitle,
      text: this.confirmMessage,
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        // try to order
        return this.api.LicenseReassign(request).toPromise();
      }
    });


  }

  async confirm() {

    await this.ProcessReassign().then(
      (response: any) => {

        // init dialog vars
        let cType = 'success';
        let cTitle = this.successTitle;
        let cMessage = this.successMessage;

        if (response.isDismissed) {
          // show cancelled
          cType = 'error';
          cTitle = this.cancelledTitle;
          cMessage = this.cancelledMessage; 
        } else if (!response.value || !response.value.Result) {
          // not ok
          cType = 'error';
          cTitle = this.errorTitle;
          cMessage = response.value.Message; // this.errorMessage;
        }

        // show result
        Swal.fire(
          {
            title: cTitle,
            text: cMessage,
            icon: cType as SweetAlertIcon,
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
          .then(() => { }, () => { }); // keep this line to prevent promise error;

      },
      (dismiss) => {
        if (dismiss === 'cancel') {

          if (!confirm)
            return;

          // show cancelled
          Swal.fire({
            title: this.cancelledTitle,
            text: this.cancelledMessage,
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000
          })
            .then(() => { }, () => { }); // keep this line to prevent promise error;
        }
      });
    this.result = true;
    this.close();
  }

  cancel() {
    // we set dialog result as true on click on confirm button,
    // then we can get dialog result from caller code
    this.result = false;
    this.close();
  }


  GetFullName(): string {
    return this.FirstName + ' ' + this.LastName;

  }

}
